export default {
  settings: {
    zh: '设置',
    en: 'Settings',
  },
  theme: {
    zh: '主题',
    en: 'Theme',
  },
  light: {
    zh: '明亮',
    en: 'Light',
  },
  dark: {
    zh: '暗黑',
    en: 'Dark',
  },
}
